import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import axiosConfig from '../../../configs/axios.config'
import { constant } from '../../../configs/constants'
import setAuthToken from '../../../utils/setAuthToken'


// Authenticate user
const loadUser = async () => {
    if (localStorage[constant.LOCAL_STORAGE_TOKEN_NAME]) {
        setAuthToken(localStorage[constant.LOCAL_STORAGE_TOKEN_NAME])
    }
    try {
        const response = await axios.create(axiosConfig).get(`api/auth`)
        localStorage.setItem(
            constant.LOCAL_STORAGE_TOKEN_NAME,
            response.data.data.refreshToken
        )
        return {success:true, user:response.data.data.user}
    } catch (error) {
        localStorage.removeItem(constant.LOCAL_STORAGE_TOKEN_NAME)
        setAuthToken('')
    }
}
// Authenticate user action
export const loadUserAction = createAsyncThunk('Auth/loadUser', async () => {
    if (localStorage[constant.LOCAL_STORAGE_TOKEN_NAME]) {
        setAuthToken(localStorage[constant.LOCAL_STORAGE_TOKEN_NAME])
    }
    else {
        return { success: false, user: undefined }
    }
    try {
        const response = await axios.create(axiosConfig).get(`api/auth`)
        localStorage.setItem(
            constant.LOCAL_STORAGE_TOKEN_NAME,
            response.data.data.refreshToken
        )
        return {success:true, user:response.data.data.user}
    } catch (error) {
        localStorage.removeItem(constant.LOCAL_STORAGE_TOKEN_NAME)
        setAuthToken('')
    }
})
// Login
export const postLogin = createAsyncThunk('Auth/login', async (userForm) => {
    try {
        console.log(axiosConfig.baseURL)
        let response = await axios.create(axiosConfig).post(`api/auth/login`, userForm)
        if (response.data.code === 200) {
            localStorage.setItem(
                constant.LOCAL_STORAGE_TOKEN_NAME,
                response.data.data.accessToken
            )
            const responseUser = await loadUser()
            return responseUser
        }
        else {
            return  {success:false, user:{}}
        }
    }
    catch (error) {
        console.log('error,', error)
    }

})
// ChangePassWord
export const postChangePassWord = createAsyncThunk('api/Auth/ChangePassWord', async (userForm) => {
    try {
        let response = await axios.create(axiosConfig).post(`api/auth/changePassword`, userForm)
        if (response.data.success === true) {
            localStorage.setItem(
                constant.LOCAL_STORAGE_TOKEN_NAME,
                response.data.accessToken
            )
            
            const responseUser = await loadUser()
            return responseUser
        }
        else {
            return response.data
        }
    }
    catch (error) {
        console.log('error,', error)
    }

})


const AuthSlice = createSlice({
    name: 'Auth',
    initialState: {
        accessToken: '',
        success: false,
        message: '',
        Loading: true,
        isAuthenticated: false,
        user: undefined,
        showModalChangePass: false
    },
    reducers: {
        // Logout
        logoutUser(state) {
            localStorage.removeItem(constant.LOCAL_STORAGE_TOKEN_NAME)
            state.isAuthenticated = false
            state.success = false
            state.user = undefined
        },
        // setshowModalChangePass
        setShowModalChangePass(state, action) {
            state.showModalChangePass = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(postChangePassWord.fulfilled, (state, action) => {
            state.Loading = false 
            state.user = action.payload.user
            state.isAuthenticated = true
            state.success = true
        })
        builder.addCase(postLogin.pending, (state, action) => {
            state.Loading = true

        })
        builder.addCase(postLogin.fulfilled, (state, action) => {
            
            state.Loading = false
            if (action?.payload?.success) {
                state.user = action.payload.user
                state.isAuthenticated = true
                state.success = true
            }
            else {
                localStorage.removeItem(constant.LOCAL_STORAGE_TOKEN_NAME)
                setAuthToken('')
                state.user = undefined
                state.message = action.payload.message
                state.success = false
                state.isAuthenticated = false
            }
        })
        builder.addCase(postLogin.rejected, (state, action) => {
            state.Loading = false
            state.isAuthenticated = false
            localStorage.removeItem(constant.LOCAL_STORAGE_TOKEN_NAME)
            setAuthToken('')
            state.user = undefined
        })
        builder.addCase(loadUserAction.fulfilled, (state, action) => {
            state.Loading = false
            if (action.payload?.success) {
                state.user = action.payload.user
                state.isAuthenticated = true
                state.success = true
            }
            else {
                state.message = action.payload.message || '1Lỗi hệ thống'
                state.success = false
            }
        })
    }
})

// Reducer
const AuthReducer = AuthSlice.reducer

// Selector
export const AuthSelector = (state) => state.AuthReducer
// Action export
export const {
    logoutUser,
    setShowModalChangePass
} = AuthSlice.actions

// Export reducer
export default AuthReducer